export default function copyPictureForLargerScreen() {
	if (innerWidth < 768) return;

	const pics = document.querySelectorAll('.cpls');

	if (pics.length === 0) return;

	for (let i = 0; i < pics.length; i++) {
		const clone = pics[i].cloneNode(true);
		const parent = document.querySelector(pics[i].dataset.selector);

		if (!parent) return;

		clone.classList.add('clone')
		parent.appendChild(clone);
	}
}
